import { Injectable } from '@angular/core';
import { BackendService } from '@tg4/http-infrastructure/dist/src';
import { Observable } from 'rxjs';
import { UserPreview } from '../../interfaces/user-preview.interface';
import { AuthService } from '../../../shared/services/auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../../services/multi-clients/config.service';

@Injectable()
export class AiManagementEvaluationService {
    apiUrl: string;

    constructor(
        private _httpService: BackendService,
        private authService: AuthService,
        private http: HttpClient,
        private _configService: ConfigService
    ) {
        this.apiUrl = this._configService.settings.apiUrl;
    }

    public getReviewsForCalibrationGroup(groupId: number, cycleId: number, selectedLanguage: string, page: number, pageSize: number, isExporting: boolean = false): Observable<any> {
        return this._httpService.get('getReviewsForCalibrationGroup', [groupId.toString()], [
            { 'name': 'cycleId', 'value': cycleId as any },
            { 'name': 'selectedLanguage', 'value': selectedLanguage as any },
            { 'name': 'pageSize', 'value': pageSize as any },
            { 'name': 'page', 'value': page as any },
            { 'name': 'isExporting', 'value': isExporting as any },
        ]);
    }


    public exportReviewAiManagement(
        cycleId: number,
        groupId: number): Observable<any> {
        return this.downloadReviewAiManagement({
            cycleId: cycleId,
            groupId: groupId
        });
    }

    downloadReviewAiManagement(data: any): any {
        const applicationsUrl =
            `${this.apiUrl}/api/report/review/management/${data.cycleId}/${data.groupId}/pdf`;

        const user = this.authService.getLoggedUser();
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': user.access_token
            }),
        };

        const impersonatedUser: UserPreview | null = this.authService.getImpersonatedUser();
        if (impersonatedUser && impersonatedUser.userId) {
            options.headers['UserIdToImpersonate'] = impersonatedUser.userId;
        }
        return this.http.post(applicationsUrl, data, options);
    }

    public exportAiSummaryReport(
        cycleId: number,
        groupId: number,
        cycleParticipantId:number): Observable<any> {
        return this.downloadAiSummaryReport({
            cycleId: cycleId,
            groupId: groupId,
            cycleParticipantId: cycleParticipantId
        });
    }

    downloadAiSummaryReport(data: {cycleId: number,groupId: number,cycleParticipantId:number}): any {
        //review/summary/{cycleId}/{groupId}/{cycleParticipantId}/pdf
        const applicationsUrl =
            `${this.apiUrl}/api/report/review/summary/pdf`;

        const user = this.authService.getLoggedUser();
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': user.access_token
            }),
        };

        const impersonatedUser: UserPreview | null = this.authService.getImpersonatedUser();
        if (impersonatedUser && impersonatedUser.userId) {
            options.headers['UserIdToImpersonate'] = impersonatedUser.userId;
        }
        return this.http.post(applicationsUrl, data, options);
    }
}
